module.exports = __webpack_public_path__ + "img/round_af.56a9ee58.svg";